import { PRICELIST_RECEIVE, PRICELIST_ERROR } from '../Actions/Pricelist.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
    errors: {},
    result:{},
}

export const pricelist = (state = defaultState, action) => {
    const { type,payload} = action;
    switch (type) {
        case PRICELIST_RECEIVE:
            return {
                ...state,
                result:payload.result
            }
        case PRICELIST_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}